export enum GroupBy {
    NoGroup = -1,
    Month = 0,
    Year = 1,
    Device = 2,
    RollingBlocks = 3,
    Quarterly = 4
}
